import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from "@angular/router";
import { UserStateService } from "@app/state/user-state.service";

export class CustomRouteReuseStrategy implements RouteReuseStrategy {

    userStateService = inject(UserStateService);

    cache = new Map<string, DetachedRouteHandle | null>();

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return (future.routeConfig === curr.routeConfig) && (future?.parent?.routeConfig?.path !== 'profile');
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const mainPath = route.parent?.url[0]?.path;
        const userNameParam = route.paramMap.get('id')!;
        const key = userNameParam;
        return (mainPath === 'profile') && !!userNameParam && this.cache.has(key);
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const userNameParam = route.paramMap.get('id')!;
        const key = userNameParam;
        return this.cache.get(key)!;
    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        const mainPath = route.parent?.url[0]?.path;
        const userNameParam = route.paramMap.get('id');
        return (mainPath === 'profile') && !!userNameParam;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
        const userNameParam = route.paramMap.get('id')!;
        const key = userNameParam;
        if (this.userStateService.userDataSnapshot?.uniqeName !== userNameParam)
            this.cache.forEach((value, key) => {
                if (key !== this.userStateService.userDataSnapshot?.uniqeName)
                    this.cache.delete(key);
            });
        this.cache.set(key, handle);
    }

}